import React, {useCallback, useState} from 'react'

import PropTypes from 'prop-types'

import MoleculeModal from '@s-ui/react-molecule-modal'
import Close from '@adv-mt/mt-svg-icons/lib/Close'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {CONTEXTS as sectionServicesContext, TRACKS} from './config.js'
import SectionServicesContent from './section-services-content.js'
import SectionServicesContentRenting from './section-services-content-renting.js'
import SectionServicesModalContent from './section-services-modal-content.js'

function SectionServices({services = [], isMainServicesIncluded = false, context = sectionServicesContext.DETAIL}) {
  const [isModalOpen, setModalState] = useState(false)
  const {track} = useAnalyticsTrack()
  const isAdContext =
    context === sectionServicesContext.DETAIL || context === sectionServicesContext.DETAIL_SUBSCRIPTION
  const isStockContext = context === sectionServicesContext.STOCK

  const isSubscriptionDetailsContext = context === sectionServicesContext.DETAIL_SUBSCRIPTION

  const handleOpenModal = useCallback(() => {
    setModalState(true)

    isAdContext && track(TRACKS.DETAIL_MODAL_OPEN)
    isStockContext && track(TRACKS.STOCK_MODAL_OPEN)
  }, [isAdContext, track, isStockContext])

  if (services.length === 0) return null

  const handleCloseModal = () => setModalState(false)

  const serviceContentProps = {
    isMainServicesIncluded,
    context,
    onButtonClick: handleOpenModal,
    onServiceClick: handleOpenModal,
    services
  }

  return (
    <div className="mt-SectionServices">
      {isSubscriptionDetailsContext ? (
        <SectionServicesContentRenting {...serviceContentProps} />
      ) : (
        <SectionServicesContent {...serviceContentProps} />
      )}
      <MoleculeModal
        closeOnOutsideClick
        closeOnEscKeyDown
        iconClose={<Close color="black" render="lazy" size="medium" />}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      >
        <SectionServicesModalContent context={context} services={services} />
      </MoleculeModal>
    </div>
  )
}

SectionServices.displayName = 'SectionServices'
SectionServices.propTypes = {
  isMainServicesIncluded: PropTypes.bool,
  services: PropTypes.array.isRequired,
  context: PropTypes.oneOf(Object.values(sectionServicesContext))
}

export {sectionServicesContext}
export default SectionServices
